/**

 * Identity and contact for Glowkit legal pages.

 * Empty `pec` is omitted in UI. Company P.IVA not set yet (persona fisica — CF only).

 * Emails use @glowkit.studio placeholders until inboxes are confirmed.

 */

export const LEGAL = {

  siteName: "Glowkit",

  siteUrl: "https://glowkit.studio",

  lastUpdated: "2026-08-08",

  controller: {

    legalName: "Damian Perez Mendoza",

    address: "Via San Simone 2P",

    vatOrTaxId: "PRZDNL99A20Z504C",

    email: "privacy@glowkit.studio",

    pec: "",

  },

  contactEmail: "ciao@glowkit.studio",

  partnerEmail: "partner@glowkit.studio",

  selectionsEmail: "selezioni@glowkit.studio",

  analyticsEnabledByEnv: process.env.REACT_APP_ENABLE_ANALYTICS === "true",

};



/** True when any controller identity field still needs operator data. */

export function hasControllerPlaceholders() {

  const { legalName, address, vatOrTaxId, pec } = LEGAL.controller;

  return [legalName, address, vatOrTaxId, pec].some((value) =>

    String(value).includes("[DA COMPILARE"),

  );

}


